/**
 *  @description 项目公参
 */
import SparkMD5 from 'spark-md5';
import env from '@/config/env';
import { appKey } from '@/omega/config';
import { getLocale, getLanguageLong } from '@/utils/locale';
import { getNetworkType, getDevice } from '@/utils/os';
import fingerprint from '@/utils/fingerprint';
import Address from '@/utils/address';
import { is_mobile, is_pad } from '@/utils/os';

const generateRequestId = (deviceId) => {
  const timestamp = Math.floor(Date.now() / 1000);
  return SparkMD5.hash(timestamp + '' + deviceId).toUpperCase();
};

export default async function getCommonParams() {
  const userPoi = Address.getAddress();

  return {
    /** @desc 地址信息 **/
    countyId: userPoi.countyId,
    countyGroupId: userPoi.countyGroupId,
    cityId: +userPoi?.cityId,
    lat: +userPoi.lat,
    lng: +userPoi.lng,
    poiId: userPoi.poiId,

    /** @desc 地址未返回的参数 **/
    poiCityId: +userPoi?.cityId,
    poiCountyId: userPoi.countyId,
    poiCountyGroupId: userPoi.countyGroupId,
    poiName: userPoi.displayName,
    poiLat: +userPoi.lat,
    poiLng: +userPoi.lng,

    /** @desc 固定参数 **/
    appVersion: '1.0.0',
    versionCode: '1.0.0',
    clientType: 6,
    brand: env.is99 ? '3' : '2',
    // dataType: 100,
    dataType: is_mobile() ? 120 : is_pad() ? 110 : 100, // 闪送B2C web 使用cookie获取token pad 110,H5 120,PC 100
    timestamp: new Date().getTime(),
    locale: getLocale(),
    lang: getLanguageLong(),
    businessType: 'C',
    terminalType: '5',
    oid: appKey,
    mapType: 'gmap',
    locationType: '-1',

    /**@desc 业务线 */
    sailingBizLine: 2,

    /** @desc 设备信息 **/
    osType: getDevice(),
    networkType: getNetworkType(),
    wifiName: 'wifi',
    osVersion: navigator.userAgent,

    /** @desc 风控 **/
    suuid: fingerprint.get(),
    imei: fingerprint.get(),
    deviceId: fingerprint.get(),
    deviceToken: fingerprint.get(),
    requestId: generateRequestId(fingerprint.get()),
  };
}
